import React, { Component } from 'react';
import FD from '../../RestAPI/fetchData';
// import GD from "../RestAPI/getData";
import Slider from 'react-slick';
import language from '../../../assets/languages/language';
import ModalComponent from '../../Common/Modal';
import Cfa3SubscriptionCheck from '../../RestAPI/Cfa3Subscription';
import PartnerCfa3SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa3Subscription';
import App_data from '../../config/App_data';
import AlertMessage from '../../config/alertMessage';
import './VideoLessons.css';
// import { getDeviceDetails } from "../../common/deviceDetails";
import { examNameAccordingToDB } from '../../../common/constant';
import { getIpAddress } from '../../../common/getIpAddress';
import AppRoutes from '../../config/AppRoutes';
/* eslint-disable*/
class VideoLessons extends Component {
  constructor(props) {
    window.scrollTo(0, 0);
    super(props);
    var messageTitle_cfa = `<i class="icon-info icons font-2xl d-block "></i>`;
    this.state = {
      alert_status: false,
      MessageTitle: messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_cfa_3,
      chapters: [],
      allChapters: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      Allchapters: [],
      itemData: [],
      subscription_details: '',
      subscription_details_for_isActive: '',
      showFreePremium: '',
      selectedmenu: 'cfa_3',
      exams: [],
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      lastRecord: '',
      lastAttempt: false,
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
  }

  slider;
  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert = () => {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  };

  goPremium = () => {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  };

  _getReadings = async (chapter, e) => {
    var chap = chapter.chapter_no;
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      chapter_id: chap,
    };
    FD.callAPI(App_data.backend_api + '/question_bank/getcfavideosChapterwise', data).then(
      async resp => {
        if (resp.success) {
          if (this.state.showFreePremium === true) {
            this.toggleAlert();
          } else if (this.state.showFreePremium === false) {
            this.context.router.push({
              pathname: AppRoutes.VIDEO_DISPLAY.replace(':id', resp.cfavchapterfirst.id)
                .replace(':showFreePremium', this.state.showFreePremium ? 0 : 1)
                .replace(':type', chapter.chapter_id === 0 ? 0 : 1)
                .replace(':chapter_id', resp.cfavchapterfirst.chapter_id)
                .replace(':index', 0),
            });
          }
        } else {
        }
      },
    );
  };

  iframe = {
    padding: 10,
  };

  async componentDidUpdate() {}

  async componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });

    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({
            showFreePremium: true,
          });
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });

          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;

                isInArray_var = await PartnerCfa3SubscriptionCheck.checkCfa3VideosSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );

                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage == '' &&
          resp.profileInfo.cfaUnlimitedActiveExam == ''
        ) {
          // console.log('if working')
          this.setState({
            showFreePremium: true,
          });
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                // console.log('selectedmen ------> ', selectedmen);
                var isInArray_var = false;

                isInArray_var = Cfa3SubscriptionCheck.checkCfa3VideosSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );

                // console.log(isInArray_var);
                if (isInArray_var) {
                  // console.log('IF WORKING')
                  this.setState({ showFreePremium: false });
                } else {
                  // console.log('ELSE WORKING')
                  this.setState({ showFreePremium: true });
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });

    var dataExam = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    FD.callAPI(App_data.backend_api + '/checkout_v1/getExams', dataExam).then(resp => {
      if (resp.success) {
        // console.log(resp);
        // console.log(resp.exams[0])
        this.setState({ ValidToken: true });
        this.setState({ exams: resp.exams[0] });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    var data_data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    await FD.callAPI(App_data.backend_api + '/cfa3_videos/getVideos', data_data).then(resp => {
      if (resp.success) {
        // console.log(resp);
        this.setState({ ValidToken: true });
        this.setState({ chapters: resp.videos });
      } else {
        this.setState({ ValidToken: false });
      }
      // return resp;
    });

    var data_data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    await FD.callAPI(App_data.backend_api + '/cfa3_videos/getlastViewedVideo', data_data).then(
      response => {
        if (response.success) {
          this.setState({
            lastRecord: response.data,
            lastAttempt: true,
          });
        }
      },
    );
  }

  goToVideo = async () => {
    // console.log('last video caseIndex -----> ', lastRecord);
    const { lastRecord, lastAttempt } = this.state;
    if (lastAttempt) {
      let path = AppRoutes.CFA3_VIDEO_DISPLAY.replace(':id', lastRecord.cfa3_video.id)
        .replace(':showFreePremium', this.state.showFreePremium ? 0 : 1)
        .replace(':type', lastRecord.cfa3_video.chapter_id === 0 ? 0 : 1)
        .replace(':chapter_id', lastRecord.cfa3_video.chapter_id)
        .replace(':index', lastRecord.caseIndex);
      this.context.router.push({
        pathname: path,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapter: lastRecord.cfa3_video,
          index: lastRecord.videoIndex,
          showFreePremium: this.state.showFreePremium,
        },
      });
    }
  };
  render() {
    var domainApp = localStorage.getItem('domainApp');
    //console.log(language.LC())
    //console.log(this.state.showFreePremium);
    const { lastAttempt } = this.state;
    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };
    let chapters = this.state.chapters;
    let exam = this.state.exams;
    // console.log(this.state.chapters);
    let data = '';
    if (this.state.chapters.length) {
      data = chapters.map((item, index) => (
        <div className='col-sm-12 col-md-12' key={index}>
          <div className='card'>
            <div className='card-header card_header_bg' value={item.id}>
              <a
                className='pointer_class'
                id={item.chapter_name}
                value={item.id}
                onClick={this._getReadings.bind(this, item)}
              >
                {language.LC().TOPIC} {index + 1} - {item.chapter_name}
              </a>
            </div>
            <div className='card-block list_icon_outer' key={item.chapter_name}>
              {item.Countvideos > 0 ? (
                <p>
                  {language.LC().TOTAL_VIDEOS}: {item.Countvideos}
                </p>
              ) : (
                <h1 className='text-danger font-weight-bold text-center'>
                  {language.LC().COMING_SOON + '....'}
                </h1>
              )}
              <div key={index} className='col-xs-12 col-sm-12 col-md-12'>
                <ChatperwiseReadingData
                  key={item.id}
                  item={item}
                  showFreePremium={this.state.showFreePremium}
                />
              </div>
            </div>
          </div>
        </div>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='video_lesson_wrap'>
        <div className='animated fadeIn'>
          <div className='margin_bottom_20 d-flex justify-content-between last_question_read'>
            <h1 className='section_head'> {language.LC().VIDEO_LESSONS} </h1>

            {lastAttempt ? (
              <button
                className='btn btn-primary pointer_class'
                onClick={this.goToVideo.bind(this)}
                disabled={!lastAttempt}
              >
                {' '}
                {language.LC().GO_TO_MY_LAST_VIDEO_VIEWED}{' '}
              </button>
            ) : null}
          </div>
          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-12'>
              <div className='bank_wrapper'>
                <div className='row'>
                  <div className='col-sm-12 col-md-12'>
                    <div className='card' />
                  </div>
                  {data}
                </div>
              </div>
            </div>
          </div>

          <ModalComponent
            goPremium={this.goPremium.bind(this)}
            toggleAlert={this.toggleAlert.bind(this)}
            alert_status={this.state.alert_status}
            MessageContent={this.state.MessageContent}
            exam={examNameAccordingToDB.CFA_LEVEL_3}
          />
        </div>
      </div>
    );
  }
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <img onClick={onClick} src='../../assets/img/right-arrow.svg' alt='' />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        fontSize: '60px',
        right: '80px',
        zIndex: '15',
        height: '20px',
        width: '40px',
        opacity: '1',
      }}
      onClick={onClick}
    >
      <img onClick={onClick} src='../../assets/img/left-arrow.svg' alt='' />
    </div>
  );
}

class ChatperwiseReadingData extends Component {
  constructor(props) {
    super(props);
    var messageTitle_cfa = `<i class="icon-info icons font-2xl d-block "></i>`;
    this.state = {
      allchapters: [],
      offset: 0,
      limit: 10,
      alert_status: false,
      MessageTitle: messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_cfa_3,
      chapters: [],
      allChapters: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      Allchapters: [],
      itemData: [],
      videoUrl: '',
      srcUrl: '',
      srcUrl_final: '',
      selectedmenu: 'cfa_3',
      showFreePremium: true,
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert = () => {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  };

  goPremium = () => {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  };

  _getReadings = async (chapter, index) => {
    // const result = getDeviceDetails();
    await this.savelastVideo(chapter, index);
    if (chapter.free === 1) {
      const data = {
        token: this.state.token,
        idname: this.state.idname,
        id: chapter.id,
        videoIndex: index,
        city: this.state.user_city,
        country: this.state.user_country,
        state: this.state.user_state,
        continent: this.state.user_continent,
        ip: this.state.user_ip,
      };
      FD.callAPI(App_data.backend_api + '/cfa3_videos/trackUserVideowatch', data).then(
        async resp => {
          if (resp.success) {
            let path = AppRoutes.CFA3_VIDEO_DISPLAY.replace(':id', chapter.id)
              .replace(':showFreePremium', this.state.showFreePremium ? 0 : 1)
              .replace(':type', chapter.chapter_id === 0 ? 0 : 1)
              .replace(':chapter_id', chapter.chapter_id)
              .replace(':index', index);
            this.context.router.push({
              pathname: path,
              state: {
                token: this.state.token,
                idname: this.state.idname,
                chapter: chapter,
                index: index,
                showFreePremium: this.state.showFreePremium,
              },
            });
          } else {
          }
        },
      );
    } else {
      // console.log('inside else fdsfdsfdsfsd34 dfsdsfdfs dsfdfsdfs');

      const data = { token: this.state.token, idname: this.state.idname };
      // console.log('inside else fdsfdsfdsfsd34 dfsdsfdfs dsfdfsdfs');
      FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
        if (resp.profileInfo.role === 'partner') {
          // console.log('I am here -----------> ', resp.profileInfo);
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this.toggleAlert();
          } else {
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });

            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              async resp_exam => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;

                  isInArray_var = await PartnerCfa3SubscriptionCheck.checkCfa3VideosSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );

                  if (isInArray_var) {
                    const data = {
                      token: this.state.token,
                      idname: this.state.idname,
                      id: chapter.id,
                      videoIndex: index,
                      city: this.state.user_city,
                      country: this.state.user_country,
                      state: this.state.user_state,
                      continent: this.state.user_continent,
                      ip: this.state.user_ip,
                    };
                    FD.callAPI(
                      App_data.backend_api + '/cfa3_videos/trackUserVideowatch',
                      data,
                    ).then(async resp => {
                      if (resp.success) {
                        let path = AppRoutes.CFA3_VIDEO_DISPLAY.replace(':id', chapter.id)
                          .replace(':showFreePremium', this.state.showFreePremium ? 0 : 1)
                          .replace(':type', chapter.chapter_id === 0 ? 0 : 1)
                          .replace(':chapter_id', chapter.chapter_id)
                          .replace(':index', index);
                        this.context.router.push({
                          pathname: path,
                          state: {
                            token: this.state.token,
                            idname: this.state.idname,
                            chapter: chapter,
                            index: index,
                            showFreePremium: this.state.showFreePremium,
                          },
                        });
                      } else {
                      }
                    });
                  } else {
                    this.toggleAlert();
                  }
                } else {
                }
              },
            );
          }
        } else {
          // console.log('I am here -----------> ', resp.profileInfo);
          if (
            resp.profileInfo.exam_selected === '' &&
            resp.profileInfo.cfaUnlimitedPackage == '' &&
            resp.profileInfo.cfaUnlimitedActiveExam == ''
          ) {
            // console.log('I am here 692');
            return this.toggleAlert();
          } else {
            // console.log('I am here 695');
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });
            // console.log('else working');
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              async resp_exam => {
                // console.log(resp_exam);
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = Cfa3SubscriptionCheck.checkCfa3VideosSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );

                  // console.log(isInArray_var);
                  if (isInArray_var) {
                    // console.log('IF WORKING')

                    const data = {
                      token: this.state.token,
                      idname: this.state.idname,
                      id: chapter.id,
                      videoIndex: index,
                      city: this.state.user_city,
                      country: this.state.user_country,
                      state: this.state.user_state,
                      continent: this.state.user_continent,
                      ip: this.state.user_ip,
                    };
                    FD.callAPI(
                      App_data.backend_api + '/cfa3_videos/trackUserVideowatch',
                      data,
                    ).then(async resp => {
                      if (resp.success) {
                        let path = AppRoutes.CFA3_VIDEO_DISPLAY.replace(':id', chapter.id)
                          .replace(':showFreePremium', this.state.showFreePremium ? 0 : 1)
                          .replace(':type', chapter.chapter_id === 0 ? 0 : 1)
                          .replace(':chapter_id', chapter.chapter_id)
                          .replace(':index', index);
                        this.context.router.push({
                          pathname: path,
                          state: {
                            token: this.state.token,
                            idname: this.state.idname,
                            chapter: chapter,
                            index: index,
                            showFreePremium: this.state.showFreePremium,
                          },
                        });
                      } else {
                      }
                    });
                  } else {
                    // console.log('ELSE WORKING')
                    return this.toggleAlert();
                  }
                } else {
                  // console.log('fail');
                }
              },
            );
          }
        }
      });
    }
  };

  savelastVideo = async (chapter, index) => {
    const { token, idname } = this.state;
    var data_data = {
      token: token,
      idname: idname,
      video_id: chapter.id,
      caseIndex: index,
    };
    await FD.callAPI(App_data.backend_api + '/cfa3_videos/saveLastViewedVideo', data_data).then(
      response => {
        if (response.success) {
          this.setState({
            ValidToken: true,
          });
        }
      },
    );
  };

  iframe = {
    padding: 10,
  };

  async componentDidMount() {
    // console.log(this.props.showFreePremium);
    // console.log(this.props);
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    this.setState({ showFreePremium: this.props.showFreePremium });
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    let dataCW = {
      token: storage_session['token'],
      chapter_id: this.props.item.id,
    };
    await FD.callAPI(App_data.backend_api + '/cfa3_videos/getvideosChapterwise', dataCW).then(
      resp => {
        if (resp.success) {
          // console.log(resp);
          this.setState({ allchapters: resp.cfavchapter });
        } else {
          this.setState({ allchapters: [] });
          this.setState({ ValidToken: false });
        }
      },
    );
  }

  videoSection = () => {
    var domainApp = localStorage.getItem('domainApp');
    let data = '';
    if (this.state.allchapters.length) {
      data = this.state.allchapters.map((item, index) => {
        // let videoUrl = item.url.split("/");
        // let srcUrl_final = (videoUrl[4].split("?"))[0];
        let count = 0;
        return (
          <div key={index}>
            {/* <div> {item.free}</div> */}
            {this.state.showFreePremium ? (
              item.free === 1 ? (
                <div className='video-type-free'>{language.LC().FREE}</div>
              ) : (
                <div className='video-type-primum'>{language.LC().PREMIUM}</div>
              )
            ) : (
              <div />
            )}
            {item.url_id_qq ? (
              <img
                width='100%'
                src={
                  item.posterImage
                    ? item.posterImage
                    : `https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-${
                        item.url_id_qq
                      }-1.jpg`
                }
                onError={({ currentTarget }) => {
                  if (!count++) {
                    // Added condition because of infinite loop, this will once only

                    currentTarget.onerror = null; // prevents looping

                    currentTarget.src = `
                    https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-${
                      item.url_id_qq
                    }-1_2.jpg`;
                  }
                }}
                value={index}
                onClick={this._getReadings.bind(this, item, index)}
                className='pointer_class slider_row'
                alt='flow player image'
              />
            ) : (
              <img
                width='100%'
                src={`https://img.youtube.com/vi/${item.url_id}/mqdefault.jpg`}
                value={index}
                onClick={this._getReadings.bind(this, item, index)}
                className='pointer_class slider_row'
                alt='youtube image'
              />
            )}

            <strong style={{ padding: '10px' }}> {item.title}</strong>
          </div>
        );
      });
    } else {
      return null;
    }
    return data;
  };

  render() {
    //console.log(this.state.showFreePremium);
    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          },
        },
      ],
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };
    return (
      <div>
        <Slider {...settings}>{this.videoSection()}</Slider>

        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
          exam={examNameAccordingToDB.CFA_LEVEL_3}
        />
      </div>
    );
  }
}

export default VideoLessons;



// WEBPACK FOOTER //
// ./src/views/CFA3/Videos/VideoLessons.js